import React from "react";
import "./about.css";
import Navbar from "../../common/navBar/navBar.tsx";
import Footer from "../../common/footer/footer.tsx";

const About = ({ showNavbar = true }: { showNavbar?: boolean }) => {
  return (
    <>
      {showNavbar && <Navbar />}

      <div className="about-page">

        {/* Floating hearts background */}
        <div className="hearts-bg">
          {Array.from({ length: 18 }).map((_, i) => (
            <span key={i} className="heart">❤</span>
          ))}
        </div>

        {/* HERO */}
        <section className="about-hero">
          <h1>Where Love Finds Its Forever</h1>
          <p>
            We bring together verified hearts, meaningful connections,
            and trusted relationships built for a lifetime of togetherness.
          </p>
        </section>

        {/* TRUST BADGES */}
        <section className="trust-section">
          <div className="trust-card">🔒 100% Verified Profiles</div>
          <div className="trust-card">❤️ Privacy Protected</div>
          <div className="trust-card">🏆 Good customer service</div>
        </section>

        {/* ABOUT CONTENT */}
        <section className="about-grid">
          <div className="glass-card">
            <h2>Our Mission</h2>
            <p>
              To redefine matrimony by combining trust, technology, and human
              connection for meaningful lifelong partnerships.
            </p>
          </div>

          <div className="glass-card">
            <h2>Our Vision</h2>
            <p>
              A world where every individual finds a partner who truly understands
              their values, dreams, and journey.
            </p>
          </div>

          <div className="glass-card">
            <h2>Our Promise</h2>
            <p>
              Safe, secure, and genuine matchmaking experience designed with love
              and responsibility.
            </p>
          </div>
        </section>

        {/* SUCCESS STORIES */}
        <section className="stories-section">
          <h2>Love Stories That Started Here 💖</h2>

          <div className="stories-wrapper">
            <div className="story-card">
              <p>
                "We connected within a week and felt like we knew each other forever.
                Truly grateful!"
              </p>
              <span>- Kavindu & Nethmi</span>
            </div>

            <div className="story-card">
              <p>
                "A perfect match made with care and trust. Best decision of our lives."
              </p>
              <span>- Arjun & Priya</span>
            </div>

            <div className="story-card">
              <p>
                "Simple, secure, and meaningful matchmaking experience."
              </p>
              <span>- Manoj & Sangeetha</span>
            </div>
          </div>
        </section>

      </div>
      {showNavbar && <Footer />}
    </>
  );
};

export default About;